// extracted by mini-css-extract-plugin
export var legendIndicator = "_c4-1";
export var legendRight = "_c4-0";